/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kvkkbasvuru_S2_R2_IdentityInputs */

const tr_kvkkbasvuru_s2_r2_identity = /** @type {(inputs: Kvkkbasvuru_S2_R2_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sistemde kayıtlı e-posta adresinden`)
};

const en_kvkkbasvuru_s2_r2_identity = /** @type {(inputs: Kvkkbasvuru_S2_R2_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From the email address registered in the system`)
};

const de_kvkkbasvuru_s2_r2_identity = /** @type {(inputs: Kvkkbasvuru_S2_R2_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Von der im System registrierten E-Mail-Adresse`)
};

const ru_kvkkbasvuru_s2_r2_identity = /** @type {(inputs: Kvkkbasvuru_S2_R2_IdentityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`С адреса электронной почты, зарегистрированного в системе`)
};

/**
* | output |
* | --- |
* | "From the email address registered in the system" |
*
* @param {Kvkkbasvuru_S2_R2_IdentityInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kvkkbasvuru_s2_r2_identity = /** @type {((inputs?: Kvkkbasvuru_S2_R2_IdentityInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kvkkbasvuru_S2_R2_IdentityInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kvkkbasvuru_s2_r2_identity(inputs)
	if (locale === "de") return de_kvkkbasvuru_s2_r2_identity(inputs)
	if (locale === "ru") return ru_kvkkbasvuru_s2_r2_identity(inputs)
	return tr_kvkkbasvuru_s2_r2_identity(inputs)
});